import { REVISION } from "three";
const version = parseInt(REVISION.replace(/\D+/g, ""));
export {
  version
};
//# sourceMappingURL=constants.js.map
